import React from "react";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
import "./App.scss";
import "./ecom-index.css";
import App from "./internal/app";

const localGlobal = global as unknown as {
  Components?: { [key: string]: any };
};

(global as any).React = React;
(global as any).ReactDOM = ReactDOM;
(global as any).ReactDOMServer = ReactDOMServer;

if (!localGlobal.Components) {
  localGlobal.Components = {};
}
localGlobal.Components.WbmMainHeaderApp = App;
